import React from "react"

import Tags from "../../common/tags/Tags"
import TagItem from "../../common/tags/TagItem"
import BackgroundImage from "../../common/BackgroundImage"

const KeyIssueListItem = ({
    id,
    activeId,
    name,
    image_url,
    subtitle,
    primary_topic,
    topic_count,
    onClick
}) => (
    <div
        className={`list-group-item${id === activeId ? " active" : ""}`}
        onClick={onClick(id)}
    >
        <BackgroundImage
            classList={["list-group-item-thumb"]}
            imageUrl={image_url}
            isThumbnail={true}
        />
        <div className="list-group-item-content">
            <h4>{name}</h4>
            <p className="text-shorten-single-line">{subtitle}</p>
            <p style={{ marginTop: "5px" }}>
                {topic_count} Related Insight Area{topic_count === 1 ? "" : "s"}
            </p>
            {primary_topic ? (
                <Tags style={{ marginTop: "10px" }}>
                    <TagItem isGrey={true}>{primary_topic.name}</TagItem>
                </Tags>
            ) : (
                <p>No primary insight area</p>
            )}
        </div>
    </div>
)

export default KeyIssueListItem
